import escapeRegExp from 'lodash/escapeRegExp'
import decodeOffsetKey from '../utils/decodeOffsetKey'

// Immutable map offsetKey -> is the cursor inside that mention search term.
// Returns null when the suggestions list should be removed.
export function getSelectionIsInsideWord(editorState:any, searches:any, mentionTrigger:string) {
    // get the current selection
    const selection = editorState.getSelection()
    const anchorKey = selection.getAnchorKey()
    const anchorOffset = selection.getAnchorOffset()

    // the list should not be visible if a range is selected or the editor has no focus
    if (!selection.isCollapsed() || !selection.getHasFocus()) {
        return null
    }

    // identify the start & end positon of each search-text
    const offsetDetails = searches.map(offsetKey => decodeOffsetKey(offsetKey))

    // a leave can be empty when it is removed due e.g. using backspace
    // do not check leaves, use full decorated portal text
    const leaves = offsetDetails
        .filter(({ blockKey }) => blockKey === anchorKey)
        .map(({ blockKey, decoratorKey }) =>
            editorState.getBlockTree(blockKey).getIn([decoratorKey])
        )

    // if all leaves are undefined the popover should be removed
    if (leaves.every(leave => leave === undefined)) {
        return null
    }

    // Checks that the cursor is after the @ character but still somewhere in
    // the word (search term). Setting it to allow the cursor to be left of
    // the @ causes troubles due selection confusion.
    const plainText = editorState.getCurrentContent().getPlainText()
    const selectionIsInsideWord = leaves
        .filter(leave => leave !== undefined)
        .map(
            ({ start, end }) =>
                (start === 0 &&
                    anchorOffset === mentionTrigger.length &&
                    plainText.charAt(anchorOffset) !== mentionTrigger &&
                    new RegExp(
                        String.raw({ raw: `${escapeRegExp(mentionTrigger)}` }),
                        'g'
                    ).test(plainText) &&
                    anchorOffset <= end) || // @ is the first character
                (anchorOffset > start + mentionTrigger.length &&
                    anchorOffset <= end) // @ is in the text or at the end
        )

    if (selectionIsInsideWord.every(isInside => isInside === false)) {
        return null
    }

    return selectionIsInsideWord
}

export function getActiveOffsetKey(selectionIsInsideWord:any):string {
    return selectionIsInsideWord
        .filter(value => value === true)
        .keySeq()
        .first()
}

export function getMentionOptionId(uniqKey:string, index:number) {
    return `mention-option-${uniqKey}-${index}`
}

export function setAriaOpened(ariaProps:any, uniqKey:string, focusedOptionIndex:number) {
    ariaProps.ariaActiveDescendantID = getMentionOptionId(uniqKey, focusedOptionIndex)
    ariaProps.ariaOwneeID = `mentions-list-${uniqKey}`
    ariaProps.ariaHasPopup = 'true'
    ariaProps.ariaExpanded = true
}

export function setAriaClosed(ariaProps:any) {
    ariaProps.ariaHasPopup = 'false'
    ariaProps.ariaExpanded = false
    ariaProps.ariaActiveDescendantID = undefined
    ariaProps.ariaOwneeID = undefined
}
